module.exports = __webpack_public_path__ + "media/images/icon_list/icon_notification_sparkling-d92ce520b213b3e65f54b2d5ca5e8eaf.svg";